import { TranslationsContext } from '@teliaee/telia-translate';
import { observer } from 'mobx-react';
import React from 'react';
import { BusinessHour, SpecialHour } from '../../stores/BranchStore';
import { useStores } from '../../stores/RootStore';
import { localizeClockHourAndMinuteSeparator } from './BranchUtil';

interface BranchOpenTimeProps {
  displayOpenText: boolean;
  hour: SpecialHour | BusinessHour;
}

export const BranchOpenTime = observer((props: BranchOpenTimeProps) => {
  const { hour, displayOpenText } = props;
  const { translate } = React.useContext(TranslationsContext);
  const { languageStore } = useStores();

  if (hour.closed) {
    return <span> {translate('branch.closed')}</span>;
  }
  return (
    <span>
      {' '}
      {displayOpenText && translate('branch.open')} {localizeClockHourAndMinuteSeparator(hour.openTime, languageStore.currentLanguage)}-
      {localizeClockHourAndMinuteSeparator(hour.closeTime, languageStore.currentLanguage)}
    </span>
  );
});
